import './AppIconGuideScreen.vars.css'

const responsiveStyles = {
  right: 'var(--app-icon-right)',
  bottom: 'var(--app-icon-bottom)'
}

export default responsiveStyles
